import React, { useMemo } from "react";
import { View, StyleSheet, Text } from "react-native";
import { useThemeSettings } from "./ThemeProvider";
import getGlobalStyles from "./globalStyles";
import { FULL_WIDTH } from "./shared/constants/dimension";
import { usePlatform } from "./providers/PlatformProvider";
import { CustomIcon } from "./components/CustomIcon";

export default function Footer() {
    const { theme } = useThemeSettings();
    const gStyles = useMemo(() => getGlobalStyles(theme), [theme]);
    const { showWebVersion } = usePlatform();
    return (
        showWebVersion ? <View style={[{ height: 52, backgroundColor: theme?.colors?.surfaceBg, paddingTop:5 }]}>
            <View style={[styles.container, {gap:24}]}>
            <CustomIcon isPressable icon="twitter" onPress={() => window.open("https://x.com/thinkonews?s=21", "_blank")}/>  
            <CustomIcon isPressable icon="instagram" onPress={() => window.open("https://www.instagram.com/thinkoai/", "_blank")}/>    
          {/*   <CustomIcon icon="medium"/>    
            <CustomIcon icon="youtube"/>  */}   
            <CustomIcon isPressable icon="linkedin" onPress={() => window.open("https://www.linkedin.com/company/thinko-ai/", "_blank")}/>    
           {/*  <CustomIcon icon="threads"/> */}      
            </View>
            <View style={styles.container}>
                <Text style={gStyles.header2}>© 2025 </Text><Text accessibilityRole="link" onPress={() => window.open("https://thinko.news", "_blank")} style={[gStyles.link, { color: theme?.colors?.primary }]}>thinkO.news</Text>
                <Text style={gStyles.header2}>. All rights reserved.</Text>
               {/*  <Text accessibilityRole="link" onPress={() => window.open("https://www.thinko.news/pages/about_us", "_blank")} style={[gStyles.link, { color: theme?.colors?.primary, borderColor: theme?.colors?.primary }]}>About Us</Text>
                <Text style={gStyles.header2}> | </Text>
                <Text accessibilityRole="link" onPress={() => window.open("https://www.thinko.news/pages/tnc", "_blank")} style={[gStyles.link, { color: theme?.colors?.primary, borderColor: theme?.colors?.primary }]}>Terms & Conditions</Text>
                <Text style={gStyles.header2}> | </Text>
                <Text accessibilityRole="link" onPress={() => window.open("https://www.thinko.news/pages/privacy_policy", "_blank")} style={[gStyles.link, { color: theme?.colors?.primary, borderColor: theme?.colors?.primary }]}>Privacy Policy</Text> */}
            </View>
        </View> : null
    );
}
const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
       
        flexDirection: "row",
        alignItems: "center",
        width: FULL_WIDTH
    }
});
